/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import "./styles.scss";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'social-media-share-button';

/**
 * This is the component description.
 */
const SocialMediaShareButton = ({
  id,
  className: userClassName,
  style,
  icon,
  // children,
  type,
  color
}) => {
  const isServer = typeof window === 'undefined';
  const link = isServer ? '' : window.location.href;

  // We can pass additional text to the social media share buttons such as the title.
  // See commented code below for an example on how to pass text.
  // It is important we encode the text with the encodeURIComponent function to pass
  // special characters (such as |, &, etc.) properly through the URL.

  // const title = isServer ? '' : encodeURIComponent(document.title)

  const defaultsMap = {
    facebook: {
      icon: 'f',
      link: `https://www.facebook.com/sharer/sharer.php?u=${link}`
      // link: `https://www.facebook.com/sharer/sharer.php?u=${link}&quote=${title}`,
    },
    twitter: {
      icon: 't',
      link: `https://twitter.com/intent/tweet?url=${link}`
      // link: `https://twitter.com/intent/tweet?text=${title}&url=${link}`,
    }
  };
  return /*#__PURE__*/React.createElement("a", {
    href: defaultsMap[type].link,
    target: "_blank",
    rel: "noreferrer",
    id: id,
    className: [baseClassName, componentClassName, `x-${color || type}`, userClassName].filter(e => e).join(' '),
    style: style
  }, /*#__PURE__*/React.createElement("button", {
    type: "button"
  }, icon || defaultsMap[type].icon));
};
SocialMediaShareButton.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   *  The children JSX
   */
  // children:PropTypes.node,

  /**
   * The Social Media to Target.
   * If blank, you need to provide both an icon letter (from glyphter) and a link.
   */
  type: PropTypes.oneOf(['twitter', 'facebook']),
  /**
   * The icon of the social media
   */
  icon: PropTypes.string,
  /**
   * The button color
   */
  color: PropTypes.string
};
SocialMediaShareButton.defaultProps = {
  // someProp:false
};
export default SocialMediaShareButton;